module.exports = __webpack_public_path__ + "media/category_icons/Neurology-89a01543.svg";